module.exports = __webpack_public_path__ + "static/media/logo.c6e73dec.png";